export default __webpack_public_path__ + "static/media/gradient.1eb54aa3.svg";